import React from 'react';
import { FormattedMessage } from 'react-intl';
import MainTitle from '../MainTitle/MainTitle';
import styles from './ReferralProgram.module.css';
import imageOne from '../../../../assets/Piece4.jpeg';
import ButtonComman from '../ButtonComponents/ButtonComman';

function ReferralProgram() {
  return (
    <section className={styles.lenderProgram}>
      <div className={styles.container}>
        <div className={styles.content}>
          <MainTitle
            title={<FormattedMessage id="ReferralProgram.title" />}
            subTitleLine={<FormattedMessage id="ReferralProgram.subtitle" />}
            className="earnMoney"
          />

          <ul className={styles.benefitsList}>
            <li className={styles.benefitItem}>
              <span className={styles.starIcon}>★</span>
              <FormattedMessage id="ReferralProgram.benefit1" />
            </li>
            <li className={styles.benefitItem}>
              <span className={styles.starIcon}>★</span>
              <FormattedMessage id="ReferralProgram.benefit2" />
            </li>
            <li className={styles.benefitItem}>
              <span className={styles.starIcon}>★</span>
              <FormattedMessage id="ReferralProgram.benefit3" />
            </li>
          </ul>

          <div className={styles.buttonGroup}>
            <ButtonComman
              title={<FormattedMessage id="ReferralProgram.browseButton" />}
              className="primaryButton"
              arrowIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-right h-4 w-4"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              }
              navigateTo="/s"
            />
            <ButtonComman
              title={<FormattedMessage id="ReferralProgram.postButton" />}
              className="secondaryButton"
              navigateTo="/l/new"
            />
          </div>
        </div>

        <div className={styles.statsContainer}>
          <div className={styles.statsImage}>
            <div className={styles.imagePlaceholder}>
              <img src={imageOne} alt="Referral Program" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReferralProgram;
